<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <TituloPrincipal titulo="Reportar Incidencia"/>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" sm="12" md="6">
               <IncidenciaAgregarComponent />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import TituloPrincipal from '@/components/utils/TituloPrincipalComponent'
import IncidenciaAgregarComponent from '../../components/reporteIncidencias/IncidenciaAgregarComponent.vue';
export default{
    components:{
        TituloPrincipal,
        IncidenciaAgregarComponent
    }
}
</script>